import React from 'react'
import { Column } from 'primereact/column'

interface TableColumnProps {
  field: string
  header: string
  sortable: boolean
}

export function TableColumn({
  field,
  header,
  sortable
}: TableColumnProps): JSX.Element {
  return <Column field={field} header={header} sortable={sortable} />
}
